//ui
export const UI_START_LOADING = "UI_START_LOADING";
export const UI_STOP_LOADING = "UI_STOP_LOADING";




// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js